import { Locale } from "@linkfluence/models/locale";
import { Mode } from "@linkfluence/models/mode";
import { UserPasswords } from "@linkfluence/models/user";
import { PublicPage } from "@radarly/models/public-pages";
import {
  CreateUser,
  DiscoveryPreferencePayload,
  SearchUserRequest,
  User,
} from "@radarly/models/user";
import { UserRepository } from "./UserRepository";

function getCurrentUserFromPublicPage(publicPage: PublicPage) {
  return {
    locale: publicPage.ctx.locale || Locale.English,
    timezone: "UTC",
    theme: Mode.Light,
  } as User;
}

export class PublicUserRepo implements UserRepository {
  user: User;
  constructor(publicPage: PublicPage) {
    this.user = getCurrentUserFromPublicPage(publicPage);
  }
  public getCurrentUser() {
    return this.user;
  }
  public fetchCurrentUser() {
    return null;
  }
  public updateCurrentUser(id: number, user: Partial<User>) {
    return null;
  }

  public getUserPictures(user: number) {
    return null;
  }
  public deleteUserPicture(id: number, picture: number) {
    return null;
  }
  public uploadUserPictures(id: number, files: File[]) {
    return null;
  }
  public closeUserBanner(banner: number) {
    return null;
  }
  public updateUserPassword(id: number, passwords: UserPasswords) {
    return null;
  }
  public resetUserPassword(email: string) {
    return null;
  }
  public searchUsers(pid: number, searchUserRequest: SearchUserRequest) {
    return null;
  }
  public getUser(pid: number, uid: number) {
    return null;
  }
  public createUser(user: CreateUser) {
    return null;
  }

  public getDiscoveryPreferences(pid: number, workspaceId: number) {
    return null;
  }

  public updateDiscoveryPreferences(
    pid: number,
    workspaceId: number,
    params: DiscoveryPreferencePayload
  ) {
    return null;
  }
}
